
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/x/api/chat/chat-message-skeleton",
      function () {
        return require("private-next-pages/x/api/chat/chat-message-skeleton.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/x/api/chat/chat-message-skeleton"])
      });
    }
  